import React, { useState, Component } from "react";
import { Button, FormGroup, FormControl, FormLabel } from "react-bootstrap";
import "./Login.css";
// import { Auth } from "aws-amplify";
import  { Redirect } from 'react-router-dom'
// import { Component } from "ag-grid-community";

export default class Login extends Component {

  // const [email, setEmail] = useState("");
  // const [password, setPassword] = useState("");

    constructor(props){
      super(props);
      this.state = {
        email: '',
        password: ''
      };
    }
    componentDidMount() {
      if (localStorage.getItem("email") && localStorage.getItem("token") ) {
        this.props.history.push("/ios-inapps");
      }
    }
   validateForm = () => {
    return this.state.email.length > 0 && this.state.password.length > 0;
  }

   handleSubmit = (event) => {
    event.preventDefault();
    //Credentials
    var userName = "geniteam@gmail.com";
    var userPassword = "admin123";
    if (userName == this.state.email && userPassword == this.state.password) {
      localStorage.setItem('email', event.target.email.value);
      localStorage.setItem('token', 'HaxGOnfpVKcKIkWgcazAkYkjvUfWIBhbKQkVkKHsSoQCakfOVIRQiRkZWVCJrKyjzTeuQGvfxOPGwtddHCM');
      return this.props.history.push('/ios-inapps')
    } else {
      alert("wrong credentials");
    }

  }

  render(){
  return (
    <div className="Login">
      <form onSubmit={this.handleSubmit}>
        <FormGroup controlId="email" bssize="large">
          <FormLabel >Email</FormLabel >
          <FormControl
            autoFocus
            type="email"
            value={this.state.email}
            onChange={e => this.setState({email: e.target.value})}
          />
        </FormGroup>
        <FormGroup controlId="password" bssize="large">
          <FormLabel >Password</FormLabel>
          <FormControl
            value={this.state.password}
            onChange={e => this.setState({password: e.target.value})}
            type="password"
          />
        </FormGroup>
        <Button block bssize="large" disabled={!this.validateForm()} type="submit">
          Login
        </Button>
      </form>
    </div>
  );
  }
}